export const hasRequiredPasswordRules = password =>
  password.length >= 8 &&
  /[A-Z]/.test(password) &&
  /[a-z]/.test(password) &&
  /\d/.test(password) &&
  /[^A-Za-z0-9\s]/.test(password);

export const isPasswordMatch = (password, passwordMatch) =>
  passwordMatch === password;
